import { render, staticRenderFns } from "./image-area-dialog.vue?vue&type=template&id=030e6ccc&"
import script from "./image-area-dialog.vue?vue&type=script&lang=js&"
export * from "./image-area-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports